import cx from 'classnames';
import { LoadingMask } from 'Elements';
import styles from 'partials/sidebar-story-loading.module.scss';

export const SidebarStoryLoading = () => {
	return (
		<div className={styles.box}>
			<div className={styles.header}>
				<div className={styles.row}>
					<LoadingMask className={cx(styles.col, styles.colMd)} />
				</div>
				<div className={cx(styles.row, 'mt-25')}>
					<LoadingMask className={cx(styles.col, styles.colSm)} />
				</div>
				<div className={styles.row}>
					<LoadingMask className={cx(styles.col, styles.colSm)} />
				</div>
			</div>
			<div className={styles.content}>
				<div className={styles.row}>
					<LoadingMask className={cx(styles.col, styles.colSm)} />
				</div>
				<div className={styles.row}>
					<LoadingMask className={cx(styles.col, styles.colLg)} />
				</div>
				<div className={styles.row}>
					<LoadingMask className={cx(styles.col, styles.colLg)} />
				</div>
				<div className={styles.row}>
					<LoadingMask className={cx(styles.col, styles.colLg)} />
				</div>
				<div className={styles.row}>
					<LoadingMask className={cx(styles.col, styles.colLg)} />
				</div>
			</div>
		</div>
	);
};
